function generateTrailPoints(startLat, startLng, durationMinutes, startTimestamp) {
  const trail = [];
  const pointsCount = Math.floor(durationMinutes / 2);

  for (let i = 0; i < pointsCount; i++) {
    const timestamp = startTimestamp - i * 2 * 60 * 1000;

    const zigzag = i % 2 === 0 ? 0.001 : -0.001;

    const lat = startLat + i * 0.0003 + zigzag;
    const lng = startLng + i * 0.0004 + zigzag * 0.5;

    trail.push({
      address: `Address ${i + 1}`,
      longitude: lng,
      latitude: lat,
      statusCode: 62465,
      statuCodeDescription: 'Ignition_On',
      statusCodeColor: '4CAF50',
      timestamp: timestamp,
    });
  }

  return trail;
}

const currentTimestamp = Date.now();
const eightHoursAgo = currentTimestamp - 8 * 60 * 60 * 1000;

const durations = [
  { minutes: 30, name: '30 min' },
  { minutes: 90, name: '1h 30m' },
  { minutes: 150, name: '2h 30m' },
  { minutes: 270, name: '4h 30m' },
  { minutes: 510, name: '8h 30m' },
  { minutes: 750, name: '12h 30m' },
];

const currentCarStartPositions = [
  { lat: 34.250501, lng: -119.207593 },
  { lat: 34.252501, lng: -119.209593 },
  { lat: 34.254501, lng: -119.211593 },
  { lat: 34.256501, lng: -119.213593 },
  { lat: 34.258501, lng: -119.215593 },
  { lat: 34.260501, lng: -119.217593 },
];

const oldCarStartPositions = [
  { lat: 34.285501, lng: -119.202593 },
  { lat: 34.287501, lng: -119.204593 },
  { lat: 34.289501, lng: -119.206593 },
  { lat: 34.291501, lng: -119.208593 },
  { lat: 34.293501, lng: -119.210593 },
  { lat: 34.295501, lng: -119.212593 },
];

const assets = [];

durations.forEach((duration, index) => {
  const startPos = currentCarStartPositions[index];
  const trail = generateTrailPoints(startPos.lat, startPos.lng, duration.minutes, currentTimestamp);

  const currentPosition =
    trail.length > 0
      ? trail[0]
      : {
          address: 'Current Address',
          longitude: startPos.lng,
          latitude: startPos.lat,
          statusCode: 62467,
          statuCodeDescription: 'Ignition_Off',
          statusCodeColor: 'F44336',
          timestamp: currentTimestamp,
        };

  assets.push({
    id: index + 1,
    gtsId: `cp${index + 1}`,
    name: `Car ${duration.name}`,
    description: `Car ${duration.name}`,
    location: currentPosition,
    trail: trail,
  });
});

durations.forEach((duration, index) => {
  const startPos = oldCarStartPositions[index];
  const trail = generateTrailPoints(startPos.lat, startPos.lng, duration.minutes, eightHoursAgo);

  const currentPosition =
    trail.length > 0
      ? trail[0]
      : {
          address: 'Current Address',
          longitude: startPos.lng,
          latitude: startPos.lat,
          statusCode: 62467,
          statuCodeDescription: 'Ignition_Off',
          statusCodeColor: 'F44336',
          timestamp: eightHoursAgo,
        };

  assets.push({
    id: index + 7,
    gtsId: `cp${index + 7}`,
    name: `Car ${duration.name} (8h ago)`,
    description: `Car ${duration.name} (8h ago)`,
    location: currentPosition,
    trail: trail,
  });
});

export const assetData = {
  destination: {},
  timeZone: '',
  location: null,
  deviceId: null,
  assets: assets,
  assetGroup: {
    id: 14243,
    gtsId: 'dispatchpowersolutions',
    name: 'Dispatch - Electrical',
  },
  accountId: '1561',
  accountIdCP: 4,
  userId: 'uat_admin@cpgps.com',
  userIdCP: 32307,
  token:
    'eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50SWQiOiIxNTYxIiwidXNlcklkIjoidWF0X2FkbWluQGNwZ3BzLmNvbSIsImFjY291bnRJZENQIjo0LCJ1c2VySWRDUCI6MzIzMDcsImlhdCI6MTc1MDc1ODQ1MiwiZXhwIjoyMDY2MjkxMjUyLCJjbGVhclNoYXJlSWQiOjU4Mn0.CGGoTfCuFHiKEF_escn46YNjDhfvJUab1XpH-t666HmIgyW_QLDXcRadFZ3Soq1Nke-eSsYX7vjx0xwkHremxQ',
  companyName: 'westCoastAir',
};
